enum ContractSetupFieldPropType {
  CHECKBOX_COUNT = 'checkboxCount',
  CHECKBOX_GROUP_MODE = 'checkboxGroupMode',
  DATA_LABEL = 'dataLabel',
  REQUIRED = 'required',
  TEXT_FIELD_ALIGN = 'textAlign',
  TEXT_FIELD_FONT_FAMILY = 'fontFamily',
  TEXT_FIELD_FONT_SIZE = 'fontSize',
}

export default ContractSetupFieldPropType;
